import { createUploadLink } from 'apollo-upload-client';

export const httpLink = createUploadLink({
  uri: '/api/graphql',
  credentials: 'include',
  headers: {
    'apollo-require-preflight': true,
  },
});
